export { SpotlightStageApiEntryPoint } from './spotlightStageApiEntry';
